import {
  Box,
  Button,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useTheme,
} from "@mui/material";

import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import SchoolIcon from "@mui/icons-material/School";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import BadgeIcon from "@mui/icons-material/Badge";
import KeyIcon from "@mui/icons-material/Key";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import RateReviewIcon from "@mui/icons-material/RateReview";
import LockIcon from "@mui/icons-material/Lock";
import HelpIcon from "@mui/icons-material/Help";
import FlagIcon from "@mui/icons-material/Flag";
import LanguageIcon from "@mui/icons-material/Language";
import TimelapseIcon from "@mui/icons-material/Timelapse";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import { useDispatch, useSelector } from "react-redux";
import { fetchListItems, openModal } from "../../redux/actions/actions";
import TableDetailsModal from "../Modal/TableDetailsModal";
import { useEffect, useState } from "react";
import axios from "axios";
import axiosInstance from "../../axiosInstance";
import NoDataFound from "../NoDataFound";
import { useTranslation } from "react-i18next";

export default function DashboardTable({
  tableHeader,
  allTableHeader,
  isMobileSm,
  isMobileMd,
  tableType,
  tableCardRefControl,
}) {
  const { t } = useTranslation();

  const theme = useTheme();
  const [filteredDatas, setFilteredDatas] = useState();
  const [rawData, setRawData] = useState();
  const selectedBranchesString = useSelector(
    (state) => state?.branches?.branchesString
  );
  const [loader, setLoader] = useState(false);
  const loginControlDef = localStorage.getItem("loginUser");
  const accessToken = localStorage.getItem("accessToken");
  const dispatch = useDispatch();
  const lightMode = useSelector((state) => state.mode.lightMode); // Redux state'inden lightMode değerini çekin

  const [bookingsTotal, setBookingsTotal] = useState();
  const [commissionsTotal, setCommissionsTotal] = useState();

  const getTableDatas = async () => {
    console.log(tableType, 'table type here');

    setLoader(true);
    try {
      const url = `${process.env.REACT_APP_BASE_URL}${tableType === "bookings" ? "dashboard/latest_bookings" : tableType
        }`;
      const response = await axiosInstance.get(url, {
        headers: {
          Authorization: `Bearer ${accessToken} `,
          XRefreshToken: `${loginControlDef} `,
          Accounts: selectedBranchesString,
          "Content-Type": "application/json",
        },
      });

      // Verileri created_at veya issue_date'e göre azalan sırada sırala
      let newData = tableType === "bookings" ? response?.data?.results : response?.data[tableType]
      const sortedData = newData?.sort((a, b) => {
        const dateA = new Date(a.created_at || a.issue_date);
        const dateB = new Date(b.created_at || b.issue_date);
        return dateB - dateA; // En yeni tarihten en eskiye sırala
      });

      // Sıralanmış verilerin ilk 10 öğesini al
      const latestTenItems = sortedData.slice(0, 10);

      // State'i güncelle
      setFilteredDatas(latestTenItems);
      setRawData(latestTenItems);
      // setFilteredDatas([]);

      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (filteredDatas?.length) {
      let totalBookingSales = 0;
      filteredDatas?.forEach((item) => {
        totalBookingSales += item?.invoice_course_price;
      });
      setBookingsTotal(totalBookingSales);
      let totalCommissionsSales = 0;
      filteredDatas?.forEach((item) => {
        totalCommissionsSales += item?.commission_amount;
      });
      setCommissionsTotal(totalCommissionsSales);
    } else {
      setBookingsTotal(0);
      setCommissionsTotal(0);
    }
  }, [filteredDatas]);

  useEffect(() => {
    if (rawData) {
      if (tableType === "bookings") {
        const uniqueInvoices = rawData.reduce((acc, current) => {
          const x = acc.find((item) => item.invoice_id === current.invoice_id);
          if (!x) {
            return acc.concat([current]);
          } else {
            x.details.check_in += `, ${current.details.check_in} `;
            x.details.check_out += `, ${current.details.check_out} `;
            return acc;
          }
        }, []);
        setFilteredDatas(uniqueInvoices);
      }
    }
  }, [rawData, tableType]); // filteredDatas değiştiğinde bu useEffect tetiklenir.

  useEffect(() => {
    // if (selectedBranchesString?.length) {
    //   getTableDatas();
    // }
    getTableDatas();
  }, [selectedBranchesString]);

  const handleOpenModal = (row) => {
    // Dispatch an action to open the modal, with the FilterModal component as the payload
    dispatch(
      openModal(<TableDetailsModal data={row} columns={allTableHeader} />)
    );
  };

  const paraFormat = (number) => {
    const formatter = new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: "GBP",
    });
    return formatter.format(number);
  };

  return loader ? (
    <Box
      sx={{
        display: "flex",
        maxWidth: "fit-content",
      }}
    >
      <CircularProgress />
    </Box>
  ) : (
    <>
      <Typography
        variant="h5"
        color={lightMode ? theme.palette.customRed.orange : "#ffffff"}
        sx={{
          fontWeight: "700",
          mr: "auto",
          width: "100%",
          p: 2,
          pb: 1,
          borderBottom: `1px dashed ${lightMode ? `#e9ecee` : `#333e47`} `,
          textTransform: 'uppercase'
        }}
      >
        {t("latest")} {tableType === "bookings" ? t("bookings") : t("commissions")}
      </Typography>
      <Box
        sx={{
          height: "100%",
          width: "100%",
          overflowY: "auto",
        }}
      >
        {filteredDatas?.length ? (
          <TableContainer
            sx={{
              height: "100%",
              p: 0,
              overflowX: "auto",
              borderRadius: 0,
              "&::-webkit-scrollbar": {
                width: "0.4em",
                height: "0.4em",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                borderRadius: "5rem",
              },
              "&::-webkit-scrollbar-thumb:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.8)",
              },
            }}
          >
            <Table
              sx={{ height: "100%" }}
              stickyHeader
              aria-label="sticky table"
            >
              <TableHead>
                <TableRow>
                  {tableHeader?.map((column, idx) => (
                    <TableCell
                      key={`${column?.label} - ${idx} `}
                      align={"center"}
                      sx={{
                        minWidth: { xs: "110px", md: "155px" },
                        fontSize: { xs: "14px", md: "14px" },
                        padding: ".5rem",
                        color: "#657381",
                        background: lightMode ? "#f4f6f8" : "#2a323d",
                        height: tableType !== "bookings" ? "50px" : "70px",
                      }}
                    >
                      {t(column.trsText)}
                    </TableCell>
                  ))}
                  {isMobileSm || isMobileMd || tableCardRefControl?.bool ? (
                    <TableCell
                      align={"center"}
                      sx={{
                        minWidth: { xs: "25%", md: "fit-content" },
                        padding: ".5rem",
                        background: lightMode ? "#f4f6f8" : "#2a323d",
                      }}
                    ></TableCell>
                  ) : null}
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredDatas?.length && tableHeader.length ? (
                  <>
                    {filteredDatas.map((row, idx) => {
                      return (
                        <TableRow
                          hover
                          tabIndex={-1}
                          key={`${row.code} - ${idx} `}
                        >
                          {tableHeader.map((column) => {
                            let value = row[column.id];
                            if (
                              typeof value === "boolean" &&
                              column.id !== "commission_paid_status"
                            ) {
                              value = value ? "Yes" : "No";
                            }
                            return (
                              <TableCell
                                sx={{
                                  padding: ".6rem",
                                  fontWeight:
                                    column.id === "status" ||
                                      column.id === "commission_paid_status"
                                      ? "700"
                                      : "400",
                                  height:
                                    tableType !== "bookings" ? "50px" : "70px",
                                }}
                                key={column.id}
                                align={"center"}
                              >
                                <Typography
                                  sx={{
                                    borderRadius: "1rem",
                                    padding: ".25rem .5rem",
                                    fontSize: { xs: "14px", md: "14px" },
                                    background:
                                      column?.id === "invoice_status"
                                        ? value === "fullypaid" ||
                                          (column.id ===
                                            "commission_paid_status" &&
                                            value)
                                          ? `linear-gradient(135deg, #00a669 0%, #02cb5e 35%, #03d959 100%)`
                                          : value === "partiallypaid"
                                            ? `linear-gradient(135deg, #D6980B 0%, #D6980B80 35%, #D6980B90 100%)`
                                            : value === "unpaid" ||
                                              (column.id ===
                                                "commission_paid_status" &&
                                                !value)
                                              ? `linear-gradient(135deg, ${theme.palette.error.dark} 0%, ${theme.palette.error.main} 35%, ${theme.palette.error.light} 100%)`
                                              : value === "overpaid"
                                                ? "blue"
                                                : value === "depositpaid"
                                                  ? "linear-gradient(135deg, #b810d5 0%, #e74dd7 35%, #ec65f7 100%)"
                                                  : lightMode
                                                    ? "#fff"
                                                    : "#212121"
                                        : lightMode
                                          ? "#fff"
                                          : "#303030",
                                    color:
                                      column?.id === "student_name"
                                        ? theme.palette.secondary.main
                                        : column?.id === "invoice_status"
                                          ? "#fff"
                                          : lightMode
                                            ? "#1C252E"
                                            : "#fff",
                                  }}
                                >
                                  {column?.format && typeof value === "number"
                                    ? column?.format(value)
                                    : column.id === "check_in"
                                      ? row?.details?.check_in
                                      : column.id === "student_name"
                                        ? row?.student_name
                                          ?.split(" ")
                                          .map(
                                            (word) =>
                                              word.charAt(0).toUpperCase() +
                                              word.slice(1).toLowerCase()
                                          )
                                          .join(" ")
                                        : column.id === "commission_type"
                                          ? row?.commission_type
                                            ?.split("_")
                                            .map(
                                              (word) =>
                                                word.charAt(0).toUpperCase() +
                                                word.slice(1)
                                            )
                                            .join(" ")
                                          : column.id === "quote_status"
                                            ? row?.quote_status
                                              ?.split(" ")
                                              .map(
                                                (word) =>
                                                  word.charAt(0).toUpperCase() +
                                                  word.slice(1).toLowerCase()
                                              )
                                              .join(" ")
                                            : column.id === "commission_paid_status" &&
                                              value
                                              ? "Paid"
                                              : column.id === "commission_paid_status" &&
                                                !value
                                                ? "Unpaid"
                                                : column?.id === "agent_name"
                                                  ? row?.created_by_agent_name
                                                    ? (value = row?.created_by_agent_name)
                                                    : (value = "")
                                                  : column.id === "check_out"
                                                    ? row?.details?.check_out
                                                    : column.id === "gross_price" ||
                                                      column.id === "invoice_course_price" ||
                                                      column.id === "commission_amount"
                                                      ? paraFormat(value)
                                                      : value === "fullypaid"
                                                        ? t("fullyPaid")
                                                        : value === "depositpaid"
                                                          ? t("depositPaid")
                                                          : value === "partiallypaid"
                                                            ? t("partiallyPaid")
                                                            : value === "overpaid"
                                                              ? t("overPaid")
                                                              : value === "unpaid"
                                                                ? t("unPaid")
                                                                : value}
                                </Typography>
                              </TableCell>
                            );
                          })}
                          {isMobileSm ||
                            isMobileMd ||
                            tableCardRefControl?.bool ? (
                            <TableCell
                              sx={{
                                padding: ".6rem",
                              }}
                              align="center"
                            >
                              <Button
                                onClick={() => {
                                  handleOpenModal(row);
                                }}
                                variant="contained"
                                sx={{
                                  textTransform: "none",
                                  padding: ".25rem",
                                }} // Düğmenin metninin büyük harf olmasını engelliyoruz
                              >
                                Details
                              </Button>
                            </TableCell>
                          ) : null}
                        </TableRow>
                      );
                    })}

                    {/* <TableRow>
                    <TableCell colSpan={"100%"} />
                    <TableCell align="center">Total</TableCell>
                    <TableCell align="center">£100.000</TableCell>
                  </TableRow> */}
                  </>
                ) : null}
              </TableBody>
            </Table>
          </TableContainer>
        ) : tableType === "bookings" ? (
          <Box
            sx={{
              width: "100%",
              height: "calc(100% - 0px)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography textTransform={"capitalize"} variant="h5">{t("noBookingsFound")}!</Typography>
          </Box>
        ) : tableType === "commissions" ? (
          <Box
            sx={{
              width: "100%",
              height: "calc(100% - 0px)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography textTransform={"capitalize"} variant="h5">{t("noCommissionsFound")}!</Typography>
          </Box>
        ) : null}
      </Box>
      <Box
        sx={{
          // backgroundColor: lightMode ? "#fffffe" : "#303030",
          color: lightMode ? "#000000" : "#ffffff",
          height: "80px",
          alignContent: "center",
          textAlign: isMobileMd ? "end" : "end",
          bottom: "0",
          left: "0",
          zIndex: "99",
          // filter: "drop-shadow(2px 2px 3px #aeaeae)",
          fontSize: isMobileMd ? "18px" : "24px",
          marginLeft: "auto",
          marginRight: { xs: "auto", lg: "0" },
          p: 2,
        }}
      >
        <span style={{ color: theme.palette.primary.main }}>
          <b>{t("total")} :</b>
        </span>{" "}
        {tableType === "bookings"
          ? paraFormat(bookingsTotal)
          : paraFormat(commissionsTotal)}
      </Box>
    </>
  );
}
